import * as React from 'react'

import type { IDrillDownFilterContextValue } from './DrillDownFilter.types'

const DrillDownFilterContext =
  React.createContext<IDrillDownFilterContextValue<unknown> | null>(null)

export const DrillDownFilterProvider = DrillDownFilterContext.Provider

export function useDrillDownFilterContext<
  T = unknown,
>(): IDrillDownFilterContextValue<T> {
  const ctx = React.useContext(DrillDownFilterContext)
  if (!ctx) {
    throw new Error(
      'DrillDownFilter compound components must be rendered within DrillDownFilterContent',
    )
  }
  return ctx as IDrillDownFilterContextValue<T>
}
